export default __webpack_public_path__ + "static/media/ABG_A01.4c37a669.mp4";